<template>
  <div class="lintje">
    <MiniMap class="mapje" :kaart="kaart" :class="{visible: minimap}"/>
    <div class="lint"  :class="{open:open}">
      <div id="left"></div>
      <div id="right">
        <div class="menuknop" >
          <div class="knoppadding" title="Sluit het menu" @click="menuClose" v-if="open">
           <img id="menuclose"    src="../assets/button_close.png"/>
          </div>
          <div class="knoppadding" title="Open het menu"  @click="menuOpen" v-else>
            <img id="menuopen" src="../assets/button_menu.png">
          </div>

        </div>
        <div id="content">
          <div class="knop" id="knop1" title="Ga naar het colofon" @click="selectMap">
            <img src="../assets/button_info.svg">
          </div>
          <div class="knop" id="knop2" title="Ga naar de Bevrijdingskrant">
            <a href="http://75jaarvrij.nl/">
              <img src="../assets/button_krant.svg">
            </a>
          </div>
        </div>
      </div>
    </div>
    <img class="logo" src="../assets/nimh_logo.svg" :class="{open: open}">
  </div>
</template>
<style scoped>

/* MiniMap */
.mapje {
  top: -60px;
  left: -20px;
  opacity: 0;
  transition: opacity 0.25s, top 0.25s;
  transition-timing-function: ease-in-out;
}
.visible {
  opacity: 1;
}

/* Menu & menu close button */
.menuknop {
  margin-top: 9px;
  vertical-align: middle;
  text-align: center;
}
.knoppadding{
  padding:3px;
}
#menuopen{
  display: inline;
}
#menuclose{
  display: inline;
}



/* Mobile screen  Lintje size*/
.lintje {
  --left-height: 50px;
  --left-width: 40px;
  --right-height: 37px;
  --right-width: 30px;
  --left-height-after: calc(var(--left-height) + 80px);
  --right-height-after: calc(var(--right-height) + 80px);
}

/* Desktop Screen Lintje size*/
@media (min-width: 768px) {
  .lintje {
    --d-left-height: 80px;
    --d-left-width: 50px;
    --d-right-width: 40px;
    --d-right-height: 50px;
    --d-left-height-after: calc(var(--d-left-height) + 80px);
    --d-right-height-after: calc(var(--d-right-height) + 80px);
  }
}

.lint {
  color: white;
  font-family: "Segoe UI", Tahoma, Geneva, Verdana, sans-serif;
  font-size: 4pt;
}

/* Buttons in menu */
.knop img {
  margin: auto;
  vertical-align: middle;
  text-align: center;
  transition: opacity 50ms ease-in-out;
}

.lint .knop {
  display: inline-flex;
  visibility: hidden;
  opacity: 0;
  width: 15px;
  height: 15px;
  margin: 7px;
  margin-top: 10px;
  text-align: center;
  transition: transform 50ms ease-in-out;
}
.lint.open #knop1 {
  visibility: visible;
  opacity: 1;
  transition: visibility 0.25s, opacity 1.1s;
  transition-timing-function: ease-in-out;
}
.lint.open #knop2 {
  visibility: visible;
  opacity: 1;
  transition: visibility 0.5s, opacity 1.1s;
  transition-timing-function: ease-in-out;
}

.knop.open {
  transform: translate(1px, -1px);
}
.knop:active {
  transform: none;
}
.knop.open img {
  opacity: 0.8;
}

.lint.open #left {
  height: var(--left-height-after);
}
.lint.open #right {
  height: var(--right-height-after);
}

.lint.open #left:before {
  top: var(--left-height-after);
}
.lint.open #left:after {
  top: var(--left-height-after);
}
.lint.open #right:before {
  top: var(--right-height-after);
}
.lint.open #right:after {
  top: var(--right-height-after);
}
#left {
  position: absolute;
  width: var(--left-width);
  height: var(--left-height);
  left: 0px;
  background: rgb(85, 87, 74);
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.25);
  transition: height 0.25s;
  transition-timing-function: ease-in-out;
}
#left:before {
  content: "";
  top: var(--left-height);
  position: absolute;
  width: 0px;
  height: 0px;
  border-top: 30px solid rgb(85, 87, 74);
  border-left: var(--left-width) solid transparent;
  transition: top 0.25s;
  transition-timing-function: ease-in-out;
}

#right {
  position: absolute;
  width: var(--right-width);
  height: var(--right-height);
  left: calc(var(--left-width) - 10px);
  background: #f18e05;
  box-shadow: 0px 4px 10px rgba(0, 0, 0, 0.5);
  transition: height 0.25s;
  transition-timing-function: ease-in-out;
  cursor: pointer;
}

#right:before {
  content: "";
  top: var(--right-height);
  position: absolute;
  width: 0px;
  height: 0px;
  border-top: 25px solid #f18e05;
  border-right: var(--right-width) solid transparent;
  transition: top 0.25s;
  transition-timing-function: ease-in-out;
}

#knop1 {
  margin-top: 15px;
}

.logo {
  position: absolute;
  left: calc(var(--right-width) + 5px);
  top: calc(var(--right-height) - 15px);
  width: 40px;
  transition: top 0.25s;
  transition-timing-function: ease-in-out;
  pointer-events: none;
}
.logo.open {
  top: calc(var(--right-height-after) - 15px);
}

@media (min-width: 768px) {
  .mapje {
    top: 150px;
    left: -20px;
    pointer-events: none;
  }
  .mapje.open {
    top: 220px;
  }
  .lint .knop {
    width: 15px;
    height: 15px;
    margin: 10px;
  }

  .lint.open #left {
    height: var(--d-left-height-after);
  }
  .lint.open #right {
    height: var(--d-right-height-after);
  }

  .lint.open #left:before {
    top: var(--d-left-height-after);
  }
  .lint.open #left:after {
    top: var(--d-left-height-after);
  }
  .lint.open #right:before {
    top:   var(--d-right-height-after);
  }
  .lint.open #right:after {
    top:  var(--d-right-height-after);
  }
  #left {
    width: var(--d-left-width);
    height: var(--d-left-height);
  }
  #left:before {
    top: var(--d-left-height);
    border-left: 50px solid transparent;
  }

  #right {
    width: var(--d-right-width);
    height: var(--d-right-height);
    left: 40px;
  }

  #right:before {
    top: var(--d-right-height);
    border-right: 40px solid transparent;
  }

  .logo {
    left: 50px;
    top: calc(var(--d-right-height) - 20px);
    width: 45px;
    transition: top 0.25s;
    transition-timing-function: ease-in-out;
  }
  .logo.open {
    top: calc(var(--d-right-height-after) - 20px);
  }

}
</style>
<script>
import MiniMap from "../components/MiniMap.vue";

export default {
  props: ["minimap", "kaart"],
  components: {
    MiniMap
  },
  data: function() {
    return {
      open: false
    };
  },
  methods: {
    selectMap: function() {
      let params = this.$route.params;
      params.source = this.$route.name;
      this.$router.push({ name: "colofon", params: params });
    },
    menuClose: function(){
      this.open = false;
    },
    menuOpen: function(){
      this.open = true;
    }
  }
};
</script>


